<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option [value]="BuildingOwner.Yes">Ja</nb-option>
  <nb-option [value]="BuildingOwner.No">Nein</nb-option>
</nb-select>

